import { Card } from "antd";
import { useEffect, useRef } from "react";

const MapSection = ({directions, height}) => {

        const mapRef = useRef(null); // Ref to hold the map instance
        // const [directions, setDirections] = useState(null); // State to hold directions
        const directionsRenderer = new window.google.maps.DirectionsRenderer()
    
        // Initialize the map
        useEffect(() => {
            mapRef.current = new window.google.maps.Map(document.getElementById('map'), {
                center: {lat: 51.5074, lng: 0.1278},
                zoom: 8,
            });
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
    
        // Update the map with directions
        useEffect(() => {
            if (directions && mapRef.current) {
                // const directionsRenderer = new window.google.maps.DirectionsRenderer();
                
                directionsRenderer.setMap(mapRef.current);
                directionsRenderer.setDirections(directions);
            }

            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [directions]);
    
        return (
            <Card>
                <div style={{width: '100%', height: height ? height : window.innerHeight - 250}}>
                    <div id="map" style={{ height: '100%', width: '100%' }}></div>
                </div>
            </Card>
        )
    
}

export default MapSection;